// extracted by mini-css-extract-plugin
module.exports = {"container":"RejectDocumentModal_container__BOT_b"};